<script lang="ts">
export enum Tab {
  Login,
  Registration,
}

export default {
  props: {
    defaultActiveTab: {
      type: Number as PropType<Tab>,
      default: () => Tab.Login,
    },
  },
  emits: ["loginClick", "registrationClick"],
  setup() {
    return {
      Tab,
    };
  },
};
</script>

<template>
  <div class="tabs">
    <button :class="{ tabs__item: true, active: defaultActiveTab === Tab.Login }" @click="$emit('loginClick')">
      {{ $gettext("Přihlášení") }}
    </button>
    <button :class="{ tabs__item: true, active: defaultActiveTab === Tab.Registration }" @click="$emit('registrationClick')">
      {{ $gettext("Registrace") }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.tabs {
  --height: 35px;
  --borderRadius: calc(var(--height) / 2);

  --bgColor: var(--white);
  --bgColorActive: var(--greenPrimary);

  display: flex;

  &__item {
    border: var(--controlBorder);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    background-color: var(--bgColor);
    height: var(--height);
    font-size: 15px;
    font-family: var(--font-family);
    padding: 0 20px;
    color: var(--gray950);
    transition: background-color var(--uiTransitionDuration) ease;

    &:first-of-type {
      border-right: 0;
      border-radius: var(--borderRadius) 0 0 var(--borderRadius);
    }
    &:last-of-type {
      border-right: var(--controlBorder);
      border-radius: 0 var(--borderRadius) var(--borderRadius) 0;
    }
    &.active {
      background-color: var(--bgColorActive);
      border: 0;
      color: var(--white);
    }
    &:hover {
      text-decoration: none;
      cursor: default;
    }
    &:hover:not(.active) {
      @include mixins.controlHoverSubtle(--bgColor);
    }
  }
}
</style>
